import { render } from "./FPluginPermissionSinglepage.vue?vue&type=template&id=2e44b988&scoped=true"
import script from "./FPluginPermissionSinglepage.vue?vue&type=script&lang=js"
export * from "./FPluginPermissionSinglepage.vue?vue&type=script&lang=js"

import "./FPluginPermissionSinglepage.vue?vue&type=style&index=0&id=2e44b988&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e44b988"]])

export default __exports__